module.exports = __webpack_public_path__ + "img/edit_message.32ac267b.svg";